import { useState } from "react";
import { toast } from "sonner";
import { Mail, Phone } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useSite } from "@/context/SiteContext";

export default function ContactPage() {
  const { settings } = useSite();
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Mensaje enviado. Te responderemos pronto.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="pt-32 md:pt-40 max-w-[1100px] mx-auto px-5 md:px-10 min-h-screen">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
        <div>
          <p className="kicker text-sunset-accent mb-4">Hablemos</p>
          <h1 className="font-serif text-5xl md:text-6xl tracking-tight mb-8">Contacto</h1>
          <p className="text-sunset-muted leading-relaxed mb-10">¿Tienes una historia, propuesta o quieres anunciarte con nosotros? Escríbenos.</p>
          <div className="space-y-4 text-sm">
            <a href={`mailto:${settings.email || "hola@sunsetmagazine.do"}`} className="flex items-center gap-3 hover:text-sunset-accent transition-colors">
              <Mail size={18} className="text-sunset-accent" /> {settings.email || "hola@sunsetmagazine.do"}
            </a>
            {settings.phone && (
              <div className="flex items-center gap-3"><Phone size={18} className="text-sunset-accent" /> {settings.phone}</div>
            )}
          </div>
        </div>

        <form onSubmit={submit} data-testid="contact-form" className="space-y-4">
          <input required data-testid="contact-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            placeholder="Nombre" className="w-full bg-white border border-sunset-border px-4 py-3.5 text-sm focus:outline-none focus:border-sunset-accent" />
          <input required type="email" data-testid="contact-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder="Correo electrónico" className="w-full bg-white border border-sunset-border px-4 py-3.5 text-sm focus:outline-none focus:border-sunset-accent" />
          <input data-testid="contact-subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })}
            placeholder="Asunto" className="w-full bg-white border border-sunset-border px-4 py-3.5 text-sm focus:outline-none focus:border-sunset-accent" />
          <textarea required rows={6} data-testid="contact-message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
            placeholder="Mensaje" className="w-full bg-white border border-sunset-border px-4 py-3.5 text-sm focus:outline-none focus:border-sunset-accent resize-none" />
          <button disabled={loading} data-testid="contact-submit"
            className="bg-sunset-ink text-white kicker px-10 py-4 hover:bg-sunset-accent transition-colors disabled:opacity-50">
            {loading ? "Enviando…" : "Enviar mensaje"}
          </button>
        </form>
      </div>
    </div>
  );
}
